var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-steps-cmp',{staticClass:"_modal",attrs:{"form-info":_vm.props.formInfo,"button":_vm.props.button,"id-event":_vm.props.idEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/regEvent.vue?vue&type=template&id=44684778&
// module id = 1405
// module chunks = 0